import React, { useState } from "react";
import {
  Form,
  FormCardContainer,
  FormSectionContainer,
  PageTitle,
} from "../style";
import styled from "styled-components";
import TextCenteredInput from "../../../Components/Form/Inputs/TextCenteredInput";
import RegularSelector from "../../../Components/Form/Dropdowns/RegularSelector";
import BigButton from "../../../Components/Form/Buttons/BigButton";
import { updateUserStatus } from "../../../Apis/Auth/Account";
import { toast } from "react-toastify";

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
  color: var(--clr-black);
`;

const actionOptions = [
  { label: "Block", value: "false" },
  { label: "Unblock", value: "true" },
];

const BlockUnblockStudent = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("false");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email || !email.trim()) {
      toast.error("Please enter the student's email");
      return;
    }

    setLoading(true);
    try {
      const boolStatus = status === "true";
      await updateUserStatus(email.trim(), boolStatus);
      setEmail("");
    } catch (error) {
      // Error toast is already triggered inside updateUserStatus
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Block/Unblock student</PageTitle>
      <FormSectionContainer>
        <FormCardContainer style={{ maxWidth: "600px" }}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <FormField>
              <TextCenteredInput
                alignText="left"
                type="email"
                placeholder="Enter email of student you wish to Block or unblock"
                name="email"
                value={email}
                onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
              />
            </FormField>

            <FormField>
              <FieldLabel>Action</FieldLabel>
              <RegularSelector
                dropdownItems={actionOptions}
                name="status"
                value={status}
                handleDropdownSelect={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setStatus(e.target.value)
                }
              />
            </FormField>

            <BigButton
              buttonText="Submit"
              disabled={loading}
              loading={loading}
              handleClick={handleSubmit}
            />
          </Form>
        </FormCardContainer>
      </FormSectionContainer>
    </>
  );
};

export default BlockUnblockStudent;
